import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { Cover } from '../../../../types/schema/cover.types';

interface GetAllCoversByPageHook {
  data: Cover[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllCoversByPage: Cover[];
    }>
  >;
}

interface GetAllCoversByPageMutationData {
  getAllCoversByPage: Cover[];
}

interface GetAllCoversByPageInputType {
  input: PaginationInput;
}

export function useGetAllCoversByPage(
  query: DocumentNode,
  input: PaginationInput
): GetAllCoversByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllCoversByPageMutationData,
    GetAllCoversByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllCoversByPage,
    loading,
    error,
    refetch,
  };
}
